module.exports = __webpack_public_path__ + "e15.no2.b3a9f248.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/e15.no2.jpg
// module id = owJW
// module chunks = 0